export const OPERATOR_ROLE_ID = "a70fdcd5-122f-4507-93ef-72735b600085";
